









































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import {
  ContractDataSignMethodEnum,
  ContractDataSignDayPartEnum,
  BookingV1ContractDateCreateRequest,
  DealStageEnum
} from '@/requests/mainApi'
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin'
import { storeModuleName } from '@/views/App/Deal/store'
import UiButton from '@/components/ui/UiButton.vue'
import UiSelect from '@/components/ui/UiSelect.vue'
import UiLabel from '@/components/ui/UiLabel.vue'

interface ISigningDateOption {
  label: string,
  value: Date,
  additionalLabel: string
}

interface ISigningTimeOption {
  label: string,
  value: ContractDataSignDayPartEnum
}

interface Data {
  signingMethod: ContractDataSignMethodEnum
  selectedDate: Date
  dates: Array<ISigningDateOption>
  dayTimes: Array<ISigningTimeOption>
  selectedTime: ContractDataSignDayPartEnum
}

interface Methods {
  addDays: (date: Date, days: number) => Date
  getMonthName: (monthNumber: number) => string
  sendData: () => Promise<void>
  sendTypeOfSigning: (data: BookingV1ContractDateCreateRequest) => Promise<void>
}

interface Computed {}

interface Props {}

export default Vue.extend({
  name: 'PaymentDetails',
  components: {
    UiButton,
    UiSelect,
    UiLabel
  },
  mixins: [iconsMixin],
  data () {
    return {
      signingMethod: 'digital',
      selectedDate: new Date(),
      dates: [],
      dayTimes: [
        {
          label: this.$t('app.signingOptions.firstHalfOfDay'),
          value: 'AM'
        },
        {
          label: this.$t('app.signingOptions.secondHalfOfDay'),
          value: 'PM'
        }
      ],
      selectedTime: 'AM'
    }
  },
  watch: {
    deal (val: any) {
      if (val.stage &&
        val.stage !== DealStageEnum.SigningOptions
      ) this.$router.push('/profile')
    }
  },
  created () {
    const weekdays = [
      this.$t('app.signingOptions.weekdays.monday'),
      this.$t('app.signingOptions.weekdays.tuesday'),
      this.$t('app.signingOptions.weekdays.wednesday'),
      this.$t('app.signingOptions.weekdays.thursday'),
      this.$t('app.signingOptions.weekdays.friday')
    ]
    let date = new Date()
    let dateToDisplay: string
    for (let i = 0; i < 31; i++) {
      date = this.addDays(date, 1)
      if (date.getDay() === 0 || date.getDay() === 6) continue
      dateToDisplay = date.getDate() + ' ' + this.getMonthName(date.getMonth())
      this.dates.push(
        {
          label: dateToDisplay,
          value: date,
          additionalLabel: weekdays[date.getDay() - 1].toString()
        })
    }
    this.selectedDate = this.dates[0].value
  },
  computed: {
    ...mapGetters(['deal'])
  },
  methods: {
    addDays (date: Date, days: number) {
      var result = new Date(date)
      result.setDate(result.getDate() + days)
      return result
    },
    getMonthName (monthNumber: number) {
      const months = [
        this.$t('app.signingOptions.months.january'),
        this.$t('app.signingOptions.months.february'),
        this.$t('app.signingOptions.months.march'),
        this.$t('app.signingOptions.months.april'),
        this.$t('app.signingOptions.months.may'),
        this.$t('app.signingOptions.months.june'),
        this.$t('app.signingOptions.months.july'),
        this.$t('app.signingOptions.months.august'),
        this.$t('app.signingOptions.months.september'),
        this.$t('app.signingOptions.months.october'),
        this.$t('app.signingOptions.months.november'),
        this.$t('app.signingOptions.months.december')
      ]
      return months[monthNumber]
    },
    async sendData () {
      await this.sendTypeOfSigning({
        data: {
          method: this.signingMethod,
          date: this.selectedDate,
          dayPart: this.selectedTime
        }
      })
      this.$router.push('/profile')
    },
    ...mapActions(storeModuleName, ['getPaymentDetails', 'getUserDocuments', 'updateDeal', 'sendPaymentDetails', 'sendTypeOfSigning'])
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
